import { FAQArray } from "../../interfaces";

const faqs: FAQArray = [
  {
    question: "How do I participate in IDO?",
    answer: `
         To get started, simply follow our participation guidelines:
          <br/><br/>
          <ul> - New to the platform? Learn how to get started step by step: <a href="https://youtu.be/n4hSKZqwsD0?si=aA5STAk5O1p7eqSB" target="_blank" style="color: #3EB8AA;">Watch a short tutorial</a> </ul>
          <ul> - Need help with onboarding? Follow our guided walkthrough: <a href="https://www.youtube.com/watch?v=UF42JHS-eFA" target="_blank" style="color: #3EB8AA;">Watch a short tutorial</a> </ul>
        `,
  },
  {
    question: "How do I subscribe to a project?",
    answer: `
          To access available projects, you need to create an account and complete the onboarding process. Once registered, you can subscribe to projects directly from your dashboard.
          <br/><br/>
          Some projects may require a short commitment period before participation.
        `,
  },
  {
    question: "When can I redeem my subscription?",
    answer: `
           You can choose between three different commitment durations, depending on the project:
            <br/><br/>
            <ul> - 3 months </ul>
            <ul> - 6 months </ul>
            <ul> - 12 months </ul>
            <br/>
            Redemption options become available once the selected period ends.
        `,
  },
  {
    question: "How can I request a refund?",
    answer: `
   Before a project becomes active, you’ll receive a notification with all final details.
   You’ll then have 12–72 hours to confirm or cancel your participation.
  <br/><br/>
   To request a refund:
  <br/>
- Go to your portfolio
- Select the relevant project
- Click “Request refund”
  <br/><br/>
Your account will be credited within 72 hours.
   `,
  },
  {
    //5
    question: "What happens after my subscription ends?",
    answer: `
            Once your subscription period ends, your access to the platform features associated with that subscription will be automatically released. You'll then be free to renew, change, or stop your subscription at any time from your account.
        `,
  },
  {
    //6
    question: "Do I earn returns by subscribing?",
    answer: `
            No. Subscriptions are designed purely to provide access to platform features and project participation. They do not generate financial returns or guaranteed outcomes.
        `,
  },
  {
    //7
    question: "Can I participate without advanced technical setup?",
    answer: `
            Yes. Simply choose Beginner mode during onboarding, and you'll be guided step by step through the entire process. No prior technical knowledge is required.
        `,
  },
  {
    //8
    question: "Does increasing my subscription level improve my benefits?",
    answer: `
            Yes. If you already have an active subscription, you can upgrade or add additional access at any time. Each subscription period is managed independently, but higher overall access levels unlock enhanced platform benefits and features.
        `,
  },
];

export default faqs;
